/**
 * LotoNumbAnalyView.js
 */



function analyInit(lotoCateg, resultObj) {

    let numbAnaly = new LotoNumbAnalyView( lotoCateg, resultObj );

	LotoGeneralInit.pageLinkEvent();
	LotoGeneralInit.addWindowScrollEvent();

};


class LotoNumbAnalyView {

    constructor(lotoCateg, lotoResult) {

		this.lotoCateg = lotoCateg;

        this.lotoBase = new LotoBase( lotoCateg, lotoResult );

        this.jikuBoo = MyUtility.makeFillArraySetVal( lotoCateg.numb+1, false, lotoCateg.numb, true);
        this.jyoBoo = MyUtility.makeFillArraySetVal( lotoCateg.numb+1, false, lotoCateg.numb, true);

        this.booArrayMap = new Map();
        this.booArrayMap.set( nominateCategory.JIKU, this.jikuBoo );
        this.booArrayMap.set( nominateCategory.JYOGAI, this.jyoBoo );

        this.bindBooArrayMap = new Map();
        this.bindBooArrayMap.set( nominateCategory.JIKU, this.jyoBoo );
        this.bindBooArrayMap.set( nominateCategory.JYOGAI, this.jikuBoo );

        this.selectMaxMap = new Map();
        this.selectMaxMap.set(nominateCategory.JIKU, 1);
        this.selectMaxMap.set(nominateCategory.JYOGAI, 5);

        this.booArrayResetIndex = this.lotoCateg.numb;

        this.nomiCategArray = [ nominateCategory.JIKU, nominateCategory.JYOGAI ];
        this.nowNomiCategIndex = 0;

        this.nowNomiContents = this.getNowNomiContents();


        // btStyle
        this.setNomiSelectBtSttyle(nominateCategory.JIKU);
        this.setNomiSelectBtSttyle(nominateCategory.JYOGAI);
        this.setCategBtStyle();

        // addEvent
        this.addEvent();


        // canvas
        this.canvasView = new LotoAnalyCanvasView(0, lotoResult);

        this.canvasView.setContObjDeploy( new NomiContents( this.lotoCateg, nominateCategory.JIKU, [], this.lotoBase ) );
        this.canvasView.paintAll();

    };


    checkBoxSelectBooArrayBt( nomiCateg, index ) {

        let booArr = this.booArrayMap.get(nomiCateg);
        let bindArr = this.bindBooArrayMap.get(nomiCateg);
        let max = this.selectMaxMap.get(nomiCateg);

        BooArrayController.selectBooArrayProcess( booArr, index, max, this.booArrayResetIndex );
        BooArrayController.bindBooArraySetProcess( booArr, bindArr, this.booArrayResetIndex );

        this.setNomiSelectBtSttyle(nominateCategory.JIKU);
		this.setNomiSelectBtSttyle(nominateCategory.JYOGAI);
		
		// canvas
		let valArray = BooArrayController.makeValueListForBooArray( booArr, LotoBase.makeFillSortArray( this.lotoCateg.numb, 1) );
		this.canvasView.setContObjDeploy( new NomiContents( this.lotoCateg, nomiCateg, valArray, this.lotoBase ) );
		this.canvasView.paintAll();

    };

    selectCategoryBt(index) {

        if(this.nowNomiCategIndex !== index) {

            if(nominateCategory.equals( this.nomiCategArray[ index ], nominateCategory.JIKU )) {
				this.jyoBoo.fill(false);   this.jyoBoo[this.lotoCateg.numb] = true;
				this.setNomiSelectBtSttyle(nominateCategory.JYOGAI);
                MyUtility.setElementStyle( 'table-jiku', 'display', 'block' );
				MyUtility.setElementStyle( 'table-jyo', 'display', 'none' );
				
				// canvas
				let valArray = BooArrayController.makeValueListForBooArray( this.jikuBoo, LotoBase.makeFillSortArray( this.lotoCateg.numb, 1) );
				this.canvasView.setContObjDeploy( new NomiContents( this.lotoCateg, nominateCategory.JIKU, valArray, this.lotoBase ) );
				this.canvasView.paintAll();

            }else {
				this.jikuBoo.fill(false);   this.jikuBoo[this.lotoCateg.numb] = true;
				this.setNomiSelectBtSttyle(nominateCategory.JIKU);
                MyUtility.setElementStyle( 'table-jiku', 'display', 'none' );
				MyUtility.setElementStyle( 'table-jyo', 'display', 'block' );
				
				// canvas
				let valArray = BooArrayController.makeValueListForBooArray( this.jyoBoo, LotoBase.makeFillSortArray( this.lotoCateg.numb, 1) );
				this.canvasView.setContObjDeploy( new NomiContents( this.lotoCateg, nominateCategory.JYOGAI, valArray, this.lotoBase ) );
				this.canvasView.paintAll();
            };
    
            this.nowNomiCategIndex = index;
            this.setCategBtStyle();
        };
    
    };

    getNowNomiContents() {

        let nomiCateg = this.nomiCategArray[ this.nowNomiCategIndex ];
        let booArray = this.booArrayMap.get( nomiCateg );
        let valList = BooArrayController.makeValueListForBooArray( booArray, LotoBase.makeFillSortArray( this.lotoCateg.numb, 1 ));

        return this.lotoBase.makeNomiContents( nomiCateg , valList);
    };



    //  add Event
    addEvent() {

		this.setSelectCategBtListener();

        this.setCheckBoxBtLisner(nominateCategory.JIKU);
        this.setCheckBoxBtLisner(nominateCategory.JYOGAI);

        // theme
        MyUtility.setElementEvent( 'bt-theme', 'click', () => this.canvasThemeChange(), false );
        
    };
    setCheckBoxBtLisner(nomiCateg) {
        let categ = nomiCateg.id;
        let booArr = this.booArrayMap.get( nomiCateg );

        for(let i=0, n=booArr.length; i<n; i++) {
            MyUtility.setElementEvent( categ+'-'+(i+1), 'click', () => this.checkBoxSelectBooArrayBt( nomiCateg, i ) );
        };
    };
    setSelectCategBtListener() {
        MyUtility.setElementEvent( 'categ-jiku', 'click', () => this.selectCategoryBt( 0 ) );
        MyUtility.setElementEvent( 'categ-jyo', 'click', () => this.selectCategoryBt( 1 ) );
    };




    //  DOM
    setNomiSelectBtSttyle(nomiCateg) {
        let categ = nomiCateg.id;
        let booArr = this.booArrayMap.get( nomiCateg );

        this.setSelectBtStyle( categ ,booArr );
    };

    setSelectBtStyle( categ ,booArr ) {
        for(let i=0, n=booArr.length; i<n; i++) {
            let bcColor = booArr[i] ? '#0077d0' : "#eeeeff";
            let color = booArr[i] ? '#ffffff' : "#0000aa";
            MyUtility.setElementStyle( categ+'-'+(i+1), 'background-color', bcColor );
            MyUtility.setElementStyle( categ+'-'+(i+1), 'color', color );
        };
    };
    setCategBtStyle() {

        const arr = this.nomiCategArray;
        for(let i=0, n=arr.length; i<n; i++) {
            let bcColor = i===this.nowNomiCategIndex ? '#0077d0' : "#eeeeff";
            let color = i===this.nowNomiCategIndex ? '#ffffff' : "#0000aa";
            let str = arr[i].id;
            MyUtility.setElementStyle( 'categ-'+str, 'background-color', bcColor );
            MyUtility.setElementStyle( 'categ-'+str, 'color', color );
        };
	};
	

	// canvas theme change
	canvasThemeChange() {
		this.canvasView.themeChange();
	};


};






//
// canvas
//

class LotoAnalyCanvasView {

	constructor(themeIndex, lotoResult ) {

		this.lotoResultArray = lotoResult.result;
	
		this._canvas1 = document.getElementById( 'canvas1' );
		this._canvas2 = document.getElementById( 'canvas2' );
	
		this.allEventAdd();
	
		this._VIEW_RANGE = [  280, 270, 260  ];
    
        this._booArraySize = 300;
		this._canvasArrayOffsetDef = this._VIEW_RANGE[0];
		this._canvasViewRange = this._booArraySize-this._canvasArrayOffsetDef;
	
		this._canvasArrayOffset = this._canvasArrayOffsetDef;
	
		this._frontNodeState = 0;

		this._rightNodeState = 0;
	
	
			//  テーマ
		this._THEME_0 = { numb: 0,  white: 'white', white2: 'rgb(210, 85, 10)', back: 'rgba(92,168,239,1)', gradaB: [ 92,168,239 ],
									gradaItv: [ 32, 17, 3 ], back2: 'rgb(62, 148, 242)', graphBack: 'rgba(105, 188, 255, 0.85)',
									strokeLine: 'rgba(5, 25, 255, 0.8)', strokeGraphF: 'rgba(37, 53, 111, 0.95)',
									graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
									movingA_S: 'rgb(210, 85, 10)',  movingA_M: 'rgb( 255, 255, 255)',
									movingA_L: 'rgb(255,255,0)'  };
	
		this._THEME_1 = { numb: 1,  white: 'white', white2: 'rgb(10, 130, 240)', back: 'rgba(50,50,50,1)', gradaB: [ 50,50,50 ],
									gradaItv: [ 40, 40, 40 ], back2: 'rgb(25, 25, 25)', graphBack: 'rgba(70, 70, 70, 1)',
									strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(5, 5, 5, 1)',
									graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
									movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
									movingA_L: 'rgb(230,230,0)'  };
	
		this._THEME_2 = { numb: 2,  white: 'rgb(30,30,30)', white2: 'rgb(255,100,30)', back: 'rgba(245,245,255,1)', gradaB: [ 240,240,255 ],
									gradaItv: [ -48, -48, -50 ], back2: 'rgb(215, 215, 235)', graphBack: 'rgba(180, 180, 200, 1)',
									strokeLine: 'rgba(10, 10, 10, 1)', strokeGraphF: 'rgba(145, 145, 205, 1)',
									graphUp: 'rgba(50, 252, 90, 0.8)', graphDown: 'rgba(230, 210, 5, 0.8)',
									movingA_S: 'rgb(10, 130, 240)',  movingA_M: 'rgb( 255, 255, 255)',
									movingA_L: 'rgb(255,255,0)'  };
	
		this._themeArray = [   this._THEME_0, this._THEME_1, this._THEME_2   ];
		this._THEME = this._themeArray[ themeIndex ];
		this._setThemeColor();
	
	};
	
	get canvasViewRange() {   return this._booArraySize-this._canvasArrayOffsetDef;   }
	
	set canvasArrayOffsetDef(val) {
	
		this._canvasArrayOffsetDef = val;
		this._canvasArrayOffset = this._canvasArrayOffsetDef;
		this.paint( this._canvasArrayOffsetDef, 'canvas1' );
	}
	
	
	_setThemeColor() {
	
		this._styleWhite = this._THEME.white;
		this._fillStyleBack = this._THEME.back;
		this._gradationBase = this._THEME.gradaB;
		this._gradationItv = this._THEME.gradaItv;
	
		this._fillStyleBack2 = this._THEME.back2;
		this._fillStyleGraphBack = this._THEME.graphBack;
	
		this._strokeStyleLine = this._THEME.strokeLine;
	
		this._strokeStyleCenterGraphFrame = this._THEME.strokeGraphF;
		this._fillStyleCenterGraphUp = this._THEME.graphUp;
		this._fillStyleCenterGraphDown = this._THEME.graphDown;

		this._movingA_S = this._THEME.movingA_S;
		this._movingA_M = this._THEME.movingA_M;
		this._movingA_L = this._THEME.movingA_L;
	
	};
	
	
	
	
	setContObjDeploy(obj) {
	
		this._Obj = obj;

		this.valArray = obj.valArray;
	
		this._booArray = this._Obj.booArray;
	
		this._indexStart = this._booArray.length-this._booArraySize;
		this._booArrRate = this._Obj.getBooArraySliceRate(this._booArraySize);
		this._booArrRateItv5 = MyUtility.booArrayIntervalCount(this._booArrRate, 5);
	
		this._percent = this._Obj.percentFormat;

		this._itvMap5 = this._Obj.getIntervalCountRate( 5, 20 );
		this._itvMap10 = this._Obj.getIntervalCountRate( 10, 20 );
	
	};
	
	
	paintAll() {
	
		this.paint( this._canvasArrayOffset, 'canvas1' );
		this.paint2( this._rightNodeState );
	};
	
	
	
	allEventAdd() {
	
		let itvVal = [ 1, 10, -10, -1 ];
		let start = 'mousedown',   end = 'mouseup';
	
		if ("ontouchstart" in window) {
			start = 'touchstart';      end = 'touchend';
			document.addEventListener("touchcancel", this._canvasTimeE(), false);
		};
		for(let i=0, n=itvVal.length; i<n; i++) {
			MyUtility.setElementEvent( 'opre_bt'+itvVal[i], start, () => this._canvasTimeS(itvVal[i]), false );
			MyUtility.setElementEvent( 'opre_bt'+itvVal[i], end, () => this._canvasTimeE(), false );
		};
	
        MyUtility.setElementEvent( 'opre_btRt', 'click', () => this._cvReset(), false );
        
		MyUtility.setElementEvent( 'opre_view', 'click', () => this.canvasViewRangeChange(), false );
		
		MyUtility.setElementEvent( 'opre_change', 'click', () => this.canvasViewPageChange(), false );
    
        
        this._canvas1.addEventListener("wheel", (e) => this.mouseWheelProcess(e) );

        //
		MyUtility.setElementEvent( 'change', 'click', () => this.canvasRtChange(), false );
	
	};
	
	
	_windowToCanvas(canvas, x, y) {
		var bbox = canvas.getBoundingClientRect();
		return {  x:  (x - bbox.left) * (canvas.width / bbox.width),
						   y:  (y - bbox.top) * (canvas.height / bbox.height)    };
	};
	
	
	mouseWheelProcess(e) {
		var loc = this._windowToCanvas( this._canvas1, e.clientX, e.clientY);
		const ofsX = this._frontNodeState===0 ? 130: 245;
		if(loc.x > 5 && loc.x < ofsX) {
			if(loc.y > 5 && loc.y < 400) {
				e.preventDefault();
				if(e.deltaY>0) {
					this._canvasF(2);
				}else {
					this._canvasF(-2);
				};
			};
		};
	};
	
	
	
	
	
	//  canvas ボタン
	
	_canvasTimeS(val) {
	
		let sig = Math.sign( val );
		let itv = Math.abs( 200/val );
		this._canvasF( sig );
		this._timer = window.setInterval( () => this._canvasF( sig ), itv );
	};
	
	_canvasTimeE() {     window.clearInterval(this._timer);     };
	
	
	
	_canvasF(val) {
		let zz = this._canvasFSub( this._canvasArrayOffset, val);
		this.paint( zz, 'canvas1' );
	};
	
	_canvasFSub( cvArrOffset, val ) {
	
		let zz = ( cvArrOffset + val );
		if(zz<0) {   zz = 0;   };
		if( zz > this._canvasArrayOffsetDef ) {   zz = this._canvasArrayOffsetDef;   };
		this._canvasArrayOffset = zz;
	
		return zz;
	};
	
	
	
	
	//  this._canvasArrayOffset  リセット
	_cvReset() {
	
		this._canvasArrayOffset = this._canvasArrayOffsetDef;
	
		this.paint( this._canvasArrayOffset, 'canvas1' );
	};
	
	
	_zzChangeBtColor( zz ) {
	
		let def = this._canvasArrayOffsetDef;
		if( zz === def ) {
			this._zzChangeBtColorSub(  'rgba(0,255,130,0.4)', '#00ff7f', '#ccccef', '#ffffff' );
		}else if(zz===0) {
			this._zzChangeBtColorSub( '#00ff7f', 'rgba(0,255,130,0.4)', '#ffffff', '#ccccef' );
		}else if( ( (def-3)<=zz && zz<=(def-1) ) ||  (1<=zz && zz<=3) ){
			this._zzChangeBtColorSub( '#00ff7f', '#00ff7f', '#ffffff', '#ffffff' );
		};
	};
	_zzChangeBtColorSub( backColor1, backColor2, color1, color2 ) {
		let itvVal = [ 1, 10, -10, -1 ];
		let backColor = [ backColor1, backColor1, backColor2, backColor2 ];
		let color = [ color1, color1, color2, color2 ];
		let btStyle = [];
		for(let i=0; i<4; i++) {
			document.getElementById( 'opre_bt'+itvVal[i] ).style.background = backColor[i];
			document.getElementById( 'opre_bt'+itvVal[i] ).style.color = color[i];
		};
    };


    canvasViewRangeChange() {
	
		for(let i=0, n=this._VIEW_RANGE.length; i<n; i++) {
			if(this._VIEW_RANGE[i]===this._canvasArrayOffsetDef) {
				this.canvasArrayOffsetDef = this._VIEW_RANGE[(i+1)%n];
				break;
			};
		};
	};

	canvasViewPageChange() {

		let val = this._frontNodeState;
	
		val = ++val%2;

		this._frontNodeState = val;
	
		this.paint( this._canvasArrayOffset, 'canvas1' );
	};
    

    // canvas state change
    canvasRtChange() {
	
		let val = this._rightNodeState;
	
		val = ++val%4;

		this._rightNodeState = val;
	
		this.paint2(val);
	};
	
	
	
	//  テーマ変更
	themeChange() {
		
		// canvas
		for(let i=0, n=this._themeArray.length; i<n; i++) {
			if( this._THEME.numb === i ) {
				this._THEME = this._themeArray[(i+1)%n];
				break;
			};
		};
		this._setThemeColor();
		this.paintAll();

		// ets
		for(let i=0; i<2; i++) {
			MyUtility.setElementStyle( 'centerLi_'+i, 'backgroundColor', this._fillStyleBack );
			MyUtility.setElementStyle( 'centerLi_'+i, 'border-color', this._styleWhite );
		};

		MyUtility.setElementStyle( 'bt-theme', 'backgroundColor', this._fillStyleBack );
		MyUtility.setElementStyle( 'bt-theme', 'border-color', this._styleWhite );
		MyUtility.setElementStyle( 'bt-theme', 'color', this._styleWhite );
		
	};
	

	
	
	
	
	//   paint
	
	paint(zz, cv) {
	
		this._zzChangeBtColor( zz );
	
		let canvas = document.getElementById( cv );
	
		if (canvas.getContext) {
	
			let context = canvas.getContext('2d');
	
			//  画面クリア
			context.fillStyle = this._fillStyleBack;
			context.fillRect(0, 0, 280, 450);
	
			if( this._frontNodeState === 0 ) {
				this._frontPage1Paint( context, zz );
			}else {
				this._frontPage2Paint( context, zz );
			};
		};
	};


	_frontPage1Paint(context, zz) {

		// 枠
		context.strokeStyle = this._styleWhite;
		context.strokeRect(5, 5, 130, 400);

		context.strokeRect(182, 270, 96, 135);

		//テキスト描画のスタイルを指定
		context.fillStyle = this._styleWhite;
		context.font = "13px 'Meiryo'";
		context.textAlign = "left";
		context.textBaseline = "top";

		//  オフセットブロック size
		let offsetBkSize = this.canvasViewRange/this._booArraySize*400;
		//  左オフセットブロック
		context.fillRect(125, 6+zz*(400/this._booArraySize), 7, offsetBkSize);
		//  右オフセットブロック
		context.fillRect(165, 5+Math.floor(zz/5)*5*(400/this._booArraySize), 7, offsetBkSize);
		//
		let arr = this._booArrRate;
		let indStart = this._indexStart;

		this._leftViewPaint(context, zz, arr, indStart);

		context.font = "13px 'Meiryo'";
		context.fillText((indStart+arr.length+1), 10, 415, 165);
		context.fillText("?", 90, 415, 20);
		context.fillRect(70, 417, 15, 15);

		//
		context.font = "14px 'Meiryo'";

		context.fillRect(212, 321, 15, 15);
		context.fillText("率", 233, 319, 20);

		let per = nominateCategory.equals(nominateCategory.JIKU, this._Obj.nomiCateg) && this._Obj.percent===1 ? "00.00" : this._percent;
		context.fillText( per+"%", 204, 345, 60);

		//
		const arrayMeta = this._booArrRateItv5;
		const arrayMetaSize = 400/arrayMeta.length;
		for(let i=0; i<arrayMeta.length; i++) {
			let ct = arrayMeta[i];

			this._paintRect(ct, context);

			context.fillRect(145, 5+i*arrayMetaSize, 15, arrayMetaSize);
		};

		for(let i=0; i<6; i++) {

			this._paintRect(i, context);

			context.fillRect(180, 19.5+i*20, 15, 10);

			context.fillStyle = this._styleWhite;
			context.fillText(i, 207, 14+i*20, 16);
		};
		context.strokeRect(179.5, 19, 16, 11);
		
	};


	_frontPage2Paint(context, zz) {

		context.strokeStyle = this._styleWhite;
		context.strokeRect(5, 5, 250, 400);

		//テキスト描画のスタイルを指定
		context.fillStyle = this._styleWhite;
		context.font = "13px 'Meiryo'";
		context.textAlign = "left";
		context.textBaseline = "top";

		//  オフセットブロック size
		let offsetBkSize = this.canvasViewRange/this._booArraySize*400;
		//  左オフセットブロック
		context.fillRect(245, 6+zz*(400/this._booArraySize), 7, offsetBkSize);
		//
		let arr = this._booArrRate;
		let indStart = this._indexStart;

		// result view
		const honNum = this.lotoResultArray[0].hon.length;
		const categOfs = (7-honNum)*7;

		let range = this.canvasViewRange;
		let boxRange = 400/range;
		let big = boxRange*0.75;
		let sml = boxRange*0.15;
		let bigG = (boxRange-big)/2;
		let smlG = (boxRange-sml)/2;
	
		let rangeX = boxRange/2;
	
		let fontSizeSub = range/50;
		let fontSize = Math.floor(boxRange*(0.25+fontSizeSub));
	
		context.font = fontSize+"px 'Meiryo'";
	
		for(let i=0; i<range; i++) {
	
			const index = i+zz+indStart;

			context.fillText(( index+1 ), 10, 4.5+i*boxRange, 55);
	
			if(arr[i+zz]==0) {
				context.fillRect(68+smlG-rangeX, 5+smlG+i*boxRange, sml, sml);
			}else {
				context.fillRect(68+bigG-rangeX, 5+bigG+i*boxRange, big, big);
			};

			const hon = this.lotoResultArray[i+zz+indStart].hon;
			for(let j=0, n=hon.length; j<n; j++) {
				const num = hon[j];
				context.fillStyle = this.valArray.some( e => e===Number(num) ) ? this._THEME.white2 : this._styleWhite;
				const textOfs = Number(num)<10 ? fontSize/4 : 0;
				context.fillText( num, categOfs+95+j*20+textOfs, 4.5+i*boxRange, fontSize);
			};

			context.fillStyle = this._styleWhite;
        };

		//
		context.font = "13px 'Meiryo'";
		context.fillText((indStart+arr.length+1), 10, 415, 165);
		context.fillText("?", 80, 415, 20);
		context.fillRect(60, 417, 15, 15);
	};



	
	_leftViewPaint( context, zz, arr, indStart ) {
	
		let range = this.canvasViewRange;
		let boxRange = 400/range;
		let big = boxRange*0.75;
		let sml = boxRange*0.15;
		let bigG = (boxRange-big)/2;
		let smlG = (boxRange-sml)/2;
	
		let rangeX = boxRange/2;
	
		let fontSizeSub = range/50;
		let fontSize = Math.floor(boxRange*(0.25+fontSizeSub));
	
		context.font = fontSize+"px 'Meiryo'";
	
		for(let i=0; i<range; i++) {
	
			context.fillText((i+zz+indStart+1), 10, 4.5+i*boxRange, 55);
	
			if(arr[i+zz]==0) {
				context.fillRect(78+smlG-rangeX, 5+smlG+i*boxRange, sml, sml);
			}else {
				context.fillRect(78+bigG-rangeX, 5+bigG+i*boxRange, big, big);
			};
        };
        
	};
	_paintRect(ct, context) {
	
		let rgb = [];
		for(let i=0; i<3; i++) {
			rgb.push( this._gradationBase[i]+(this._gradationItv[i]*ct) );
		};
		context.fillStyle = 'rgba('+rgb[0]+','+rgb[1]+','+rgb[2]+',1)';
	};
	
	

	paint2(val) {
	
		var zz10Ct = [];
		var zz5Ct = [];
	
		for(var i=0, n=this._itvMap5.length; i<n; i++) {
			zz10Ct.push( this._itvMap10[i]/10*120 );
			zz5Ct.push( this._itvMap5[i]/5*120 );
		};
	
		let indStart = this._indexStart;
	
		var range10Top = indStart+this._booArraySize-this._itvMap10.length*10;
		var range5Top = indStart+this._booArraySize-this._itvMap5.length*5;
	
	
		var canvas = document.getElementById( 'canvas2' );
		if (canvas.getContext) {
	
			var context = canvas.getContext('2d');
	
			//  画面クリア
			context.fillStyle =  this._fillStyleBack;
			context.fillRect(0, 0, 280, 450);
	
			if(val==0) {
                this.paint2Sub(context, this._itvMap5, (this._Obj.percent*5).toFixed(1), zz5Ct, 5, range5Top, 5 );
			}else if(val==1) {
                this.paint2Sub(context, this._itvMap10, (this._Obj.percent*10).toFixed(1), zz10Ct, 5, range10Top, 10 );
			}else {
				this.paint3MovingAverage( context, val );
			};
		};
	};
	
	
	paint2Sub( context ,zzArr, th, zzCt, ofsY, rangeTop, range ) {
	
		context.fillStyle = this._fillStyleGraphBack;
		for(var i=0, n=zzCt.length; i<n; i++) {
			context.fillRect(150, 20+i*20+ofsY, 120, 13);
		};
	
		context.strokeStyle = this._styleWhite;
		context.strokeRect(20, 140+ofsY, 90, 150);
	
		context.fillStyle = this._styleWhite;
		context.textAlign = "center";
		context.textBaseline = "top";
	
		context.font = "16px 'Meiryo'";
	
		context.fillText( "間隔. "+range, 65, 175+ofsY, 95);
	
		context.font = "15px 'Meiryo'";
	
		context.fillText( "理論値", 65, 215+ofsY, 60);
		context.fillText( th, 65, 237+ofsY, 60);
	
		for(var i=0, n=zzArr.length; i<n; i++) {
			context.fillText( zzArr[ i ], 135, 18+i*20+ofsY, 60);
		};
	
		context.textAlign = "left";
		context.fillText( '~ '+(rangeTop+1)+'回', 48, 18+ofsY, 62);
		context.fillText( rangeTop+range*zzArr.length+'回 ~', 48, 398+ofsY, 62);
	
		//
		context.beginPath();
		context.strokeStyle = this._strokeStyleLine;
		var ofs = 150+( 120 * this._Obj.percent );
		context.moveTo(ofs, 17+ofsY);
		context.lineTo(ofs, 415+ofsY);
		context.stroke();
		//context.closePath();
		//
		for(var i=0, n=zzCt.length; i<n; i++) {
			context.fillRect(150, 20+i*20+ofsY, zzCt[i], 13);
		};
	
		context.textAlign = "center";
		context.font = "14px 'Meiryo'";
		context.fillText(range, 268, 2+ofsY-10, 30);
		context.fillText( th, ofs-2, 2+ofsY+1.5, 30);
	
	};

	paint3MovingAverage( context, type ) {

        /*
		let arrayS = type==2 ? this.makeWeightedMovingAverage(25, 200, this._booArray) : this.makeExponentialMovingAverage(25, 200, this._booArray);
		let arrayM = type==2 ? this.makeWeightedMovingAverage(100, 200, this._booArray) : this.makeExponentialMovingAverage(100, 200, this._booArray);
		let arrayL = type==2 ? this.makeWeightedMovingAverage(300, 200, this._booArray) : this.makeExponentialMovingAverage(300, 200, this._booArray);
        */
    	let mvAvType = type==2 ? movingAverageType.WEIGHT : movingAverageType.EXPONENTIAL;
    	let arrayS = this._Obj.getMovingAverage(mvAvType, 25, 200);
    	let arrayM = this._Obj.getMovingAverage(mvAvType, 100, 200);
    	let arrayL = this._Obj.getMovingAverage(mvAvType, 300, 200);

		let maText = type==2 ? "加重" : "独自";
		//
		let ofx = 65;
		let ofy = 30
		let width = 210;
		let height = 400;
		context.fillStyle = this._fillStyleGraphBack;
		context.fillRect(ofx, ofy, width, height);
		context.strokeStyle = this._styleWhite;
		context.strokeRect( ofx, ofy, width, height);

		let per = (this._percent/100);
		let perText = this._percent;

		//  text
		context.fillStyle = this._styleWhite;
		context.textAlign = "left";
		context.font = "13px 'Meiryo'";

		context.fillText( maText, 5, 5, 65);
		context.fillText( "S-25", 65, 435, 30);
		context.fillText( "M-100", 140, 435, 30);
		context.fillText( "L-300", 210, 435, 30);

		context.font = "13px 'Meiryo'";
		context.fillText( 0, 63, 0, 20);
		context.fillText( perText, ofx+width*per-20, 12, 50);
		context.fillText( 100, 255, 0, 25);
		let index = [ -200, -150, -100, -50, 0 ];
		context.textAlign = "center";
		for(let i=0; i<5; i++) {
			let y = Math.round(ofy+height/4*i)-10;
			context.fillText( index[i], 45, y, 40);
		};

		//
		context.lineWidth = 0.5;

		context.strokeStyle = this._strokeStyleLine;
		context.beginPath();
		context.moveTo( Math.round(ofx+width*per), ofy);
		context.lineTo( Math.round(ofx+width*per), height+ofy);
		context.stroke();
		context.strokeStyle = this._styleWhite;
		for(let i=1; i<4; i++) {
			context.beginPath();
			let y = Math.round(ofy+height/4*i);
			context.moveTo( ofx, y);
			context.lineTo( ofx+width, y);
			context.stroke();	
		};


		//
		context.lineJoin = "round";
		context.lineWidth = 1.3;

		context.strokeStyle = this._movingA_L;
		context.beginPath();
		context.moveTo(  ofx+arrayL[0]*width, ofy );
		for(let i=1, n=arrayL.length; i<n; i++) {
			context.lineTo( ofx+arrayL[i]*width, ofy+i*2);
		};
		context.stroke();
		context.beginPath();
		context.moveTo( 245+5, 445);
		context.lineTo( 245+20, 445);
		context.stroke();	


		context.strokeStyle = this._movingA_M;
		context.beginPath();
		context.moveTo(  ofx+arrayM[0]*width, ofy );
		for(let i=1, n=arrayM.length; i<n; i++) {
			context.lineTo( ofx+arrayM[i]*width, ofy+i*2);
		};
		context.stroke();
		context.beginPath();
		context.moveTo( 170+5, 445);
		context.lineTo( 170+20, 445);
		context.stroke();	

		context.strokeStyle = this._movingA_S;
		context.beginPath();
		context.moveTo(  ofx+arrayS[0]*width, ofy );
		for(let i=1, n=arrayS.length; i<n; i++) {
			context.lineTo( ofx+arrayS[i]*width, ofy+i*2);
		};
		context.stroke();
		context.beginPath();
		context.moveTo( 95+5, 445);
		context.lineTo( 95+20, 445);
		context.stroke();	

	};
	/*
	makeWeightedMovingAverage(range, rate, target) {

		let weight = (range+1)*(range/2.0);

		let resultArr = this.makeArray(rate, 0.0);

		for(let i=rate; i>0; i--) {
			let rateIndex = target.length-i;
			for(let j=1; j<=range; j++) {
				if(target[ rateIndex-( range-j ) ]) {  resultArr[rate-i] += j;  }
			};
			resultArr[rate-i] = resultArr[rate-i]/weight;
		};
		return resultArr;
	};
	makeExponentialMovingAverage(range, rate, target) {

		let resultArr = this.makeArray(rate, 0.0);

		let exponentialCount = 0.0;
		for(let i=1; i<=range; i++) {
			exponentialCount += Math.sqrt(i);
		};
		for(let i=rate; i>0; i--) {
			let rateIndex = target.length-i;
			for(var j=1; j<=range; j++) {
				if(target[ rateIndex-( range-j ) ]) {  resultArr[rate-i] += Math.sqrt(j);  }
			};
			resultArr[rate-i] = resultArr[rate-i]/exponentialCount;
		};
		return resultArr;
	};
	makeArray(size, fill) {
		let array = [];
		for(let i=0; i<size; i++) {   array.push(fill);   };
		return array;
	};
	*/
	

	
	
	
};
	
	
